(function () {
  function initSlideshow(wrapper) {
    if (!wrapper || wrapper.dataset.sliderReady === 'true') return;

    const slider = wrapper.querySelector('[data-slider]');
    const dotsWrapper = wrapper.querySelector('[data-dots]');
    if (!slider) return;

    const originalSlides = [...slider.querySelectorAll('[data-original="true"]')];
    const total = originalSlides.length;
    if (total <= 1) return;
    wrapper.dataset.sliderReady = 'true';

    const AUTOPLAY_MS =
      (parseFloat(getComputedStyle(wrapper).getPropertyValue('--autoplay-duration')) || 7) * 1000;
    const dots = dotsWrapper ? [...dotsWrapper.children] : [];

    let currentIndex = 0;          // real slide index 0..total-1
    let autoplayInterval = null;
    let isUserInteracting = false;
    let isJumping = false;
    let scrollTimeout;

    // Track positions: 0 = clone of last | 1..total = real slides | total+1 = clone of first
    const width = () => slider.clientWidth; // live, so resize/rotation doesn't break it

    // CHANGED: same mechanism as the original code (inline scroll-behavior + scrollLeft)
    // so the smooth slide animation plays; jumps force 'auto' so they stay invisible
    const scrollToPos = (pos, smooth) => {
      slider.style.scrollBehavior = smooth ? 'smooth' : 'auto';
      slider.scrollLeft = pos * width();
    };

    // Instant reposition that the scroll listener ignores
    const jumpTo = (pos) => {
      isJumping = true;
      scrollToPos(pos, false);
      requestAnimationFrame(() => requestAnimationFrame(() => { isJumping = false; }));
    };

    // Clones for infinite loop
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[total - 1].cloneNode(true);
    firstClone.removeAttribute('data-original');
    lastClone.removeAttribute('data-original');
    firstClone.setAttribute('data-clone', 'first');
    lastClone.setAttribute('data-clone', 'last');
    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, slider.firstChild);

    // Jump to real slide 1 instantly, in the same task as the clone insert,
    // so the browser never paints the prepended clone (fixes the load flash)
    jumpTo(1);

    // CHANGED: no forced reflow (it could interrupt the smooth scroll);
    // double rAF lets the inactive state render first so the progress bar restarts
    const updateActive = () => {
      dots.forEach((dot) => { dot.dataset.active = 'false'; });
      const activeDot = dots[currentIndex];
      if (!activeDot) return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (dots[currentIndex] === activeDot) activeDot.dataset.active = 'true';
      }));
    };

    const stopAutoplay = () => {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    };

    const goNext = () => {
      if (currentIndex === total - 1) {
        currentIndex = 0;
        scrollToPos(total + 1, true); // go forward into first-clone; onScrollEnd swaps to real first
      } else {
        currentIndex += 1;
        scrollToPos(currentIndex + 1, true);
      }
      updateActive();
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        if (!isUserInteracting && !isJumping && !document.hidden) goNext();
      }, AUTOPLAY_MS);
    };

    const onScrollEnd = () => {
      const pos = Math.round(slider.scrollLeft / width());
      let newIndex;
      if (pos >= total + 1) { newIndex = 0; jumpTo(1); }             // on first-clone → real first
      else if (pos <= 0)    { newIndex = total - 1; jumpTo(total); } // on last-clone → real last
      else                  { newIndex = pos - 1; }

      const changed = newIndex !== currentIndex;
      currentIndex = newIndex;

      if (isUserInteracting) {
        isUserInteracting = false;
        updateActive();
        startAutoplay();
      } else if (changed) {
        updateActive();
      }
    };

    // Dots
    dots.forEach((dot) => {
      const handleDot = (e) => {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = Number(dot.dataset.index);
        scrollToPos(currentIndex + 1, true);
        updateActive();
        startAutoplay();
        dot.blur();
      };
      dot.addEventListener('click', handleDot);
      dot.addEventListener('touchend', handleDot, { passive: false });
    });

    // User input (swipe / horizontal trackpad)
    const onUserStart = () => { isUserInteracting = true; stopAutoplay(); };
    slider.addEventListener('touchstart', onUserStart, { passive: true });
    slider.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) onUserStart();
    }, { passive: true });
    slider.addEventListener('touchend', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onScrollEnd, 120); // restarts autoplay even if no horizontal scroll happened
    }, { passive: true });

    slider.addEventListener('scroll', () => {
      if (isJumping) return;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onScrollEnd, 120);
    }, { passive: true });

    // Keep position correct on width change (ignores mobile URL-bar height changes)
    let lastWidth = width();
    window.addEventListener('resize', () => {
      const w = width();
      if (w === lastWidth) return;
      lastWidth = w;
      jumpTo(currentIndex + 1);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else { updateActive(); startAutoplay(); }
    });

    updateActive();
    startAutoplay();
  }

  const boot = () => document.querySelectorAll('[data-slideshow-wrapper]').forEach(initSlideshow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      initSlideshow(e.target.querySelector('[data-slideshow-wrapper]'));
    });
  }
})();